/*
 * @Author: Will Keung Lau
 * @Date: 2025-04-18 17:24:49
 * @LastEditors: Will Keung Lau
 * @LastEditTime: 2025-05-12 14:59:45
 * @Description:  头部注释
 */
import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import App from './page/index';
import { axios, Loadable as loadable } from 'marmot_design_ui';
import Cookies from 'js-cookie';
import './assets/style/commonStyle.less';
import 'handsontable/dist/handsontable.full.css';

if (process.env.NODE_ENV === 'development') {
    axios.setToken('C13D867DBD52102813BFC7F0A27526E286373698076777676855536132811095984');
    sessionStorage.setItem(
        'feConfig',
        JSON.stringify({
            apiHost: 'api-test.dbxiao.cn',
            platformName: '教育数据中台',
        }),
    );
} else {
    axios.setToken(Cookies.get('token') || '');
}

const home = loadable(() => import('./page/home'));
const result = loadable(() => import('./page/result'));

function Main() {
    let MyApp = withRouter(App);
    const userAgent = navigator.userAgent;
    console.info(userAgent, 'userAgent');
    return (
        <MyApp
            appName="KNOWLEDGE_GUIDE"
            HideHeader={process.env.REACT_APP_SHOW_HEADER === 'hide' || navigator?.userAgent.includes('ua_iboxiao')}
        >
            <Switch>
                <Route path="/index" component={home} />
                <Route path="/result/:searchdata" component={result} />
                <Redirect from="/" exact to="/index" />
            </Switch>
        </MyApp>
    );
}

export default Main;
